import { Fetch } from '.';
import { NodeType } from '../enums/NodeType';
import {
  Metadata,
  Schema,
  WorkspaceSetting,
  WorkspaceSettingProps
} from '../types/Metadata';
import { View } from '../types/View';

export interface Payload {
  schema: Schema;
  type: NodeType | string;
  refId: string;
  workspaceRefId: string;
  folderRefId: string;
  view: View.Setting;
  viewRefId: string;
  folder: View.Folder;
  folderName: string;
  value: any;
  itemId: number;
  views: any;
  folders: any;
}

type CRResp = { createdWorkspace: boolean; myItemsViewsCreated: number };
export const createWorkspace =
  (f: Fetch) => async (payload: Pick<Payload, 'value'>) =>
    f.fetchJSON<CRResp>(payload, '/admin/workspace', 'POST');

export const upsertUserSettings =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'refId' | 'value'>): Promise<void> =>
    f.fetchJSON<void>(payload, '/admin/user/setting', 'POST');

export const upsertWorkspaceSettings =
  (f: Fetch) =>
  async (refId: string, setting: Partial<WorkspaceSettingProps>) =>
    f.fetchJSON<WorkspaceSetting>(
      setting,
      `/admin/workspace/setting/${refId}`,
      'POST'
    );

export const createSchema =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'schema'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/schema', 'POST');

export const updateSchema =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'schema'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/schema', 'PUT');

export const deleteSchema =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'refId' | 'type' | 'workspaceRefId'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/schema', 'DELETE');

export const cloneView =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'refId' | 'folderRefId'>
  ): Promise<Metadata> =>
    f.fetchJSON<Metadata>(payload, '/admin/clone/view', 'POST');

export const cloneFolder =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'folderRefId'>
  ): Promise<Metadata> =>
    f.fetchJSON<Metadata>(payload, '/admin/clone/folder', 'POST');

export const createView =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'view' | 'folderRefId'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/view', 'POST');

export const updateView =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'view' | 'folderRefId'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/view', 'PUT');

export const deleteView =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'refId'>): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/view', 'DELETE');

export const moveView =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'views' | 'folders'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/move/view', 'PUT');

export const createFolder =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'folderName' | 'folderRefId'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/folder', 'POST');

export const updateFolder =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'folderName'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/folder', 'PUT');

export const deleteFolder =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'folderRefId'>): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/folder', 'DELETE');

export const createRegressionTestFile =
  (f: Fetch) =>
  async (payload: boolean): Promise<any> =>
    f.fetchJSON<any>(payload, '/instantiate-file-name', 'POST');

export interface UserInfo {
  jobRoles: string[];
  researchPractice: string;
  empCd: number;
  empHdcLevel1: string;
}

export const getUserInfo =
  (f: Fetch) => async (): Promise<Metadata<UserInfo>> =>
    f.getJSON<any>('/admin/user/info');
